module.exports = __webpack_public_path__ + "img/default_topic.256b9f05.jpg";